import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type { IInventoryItem } from './dataService';

export function genComponentAndControllerGenerator(hasListingsForStoreId?: string) {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery(hasListingsForStoreId),
    fnGetObjectLabel: object => object.displayName
  });
}
